import InputType from "common/form/InputType";
import { Form, Input } from "decorator-form";

@Form({title: "Organization User List Config"})
export default class Config {

	@Input({type: InputType.TEXT, title: "Widget Title"})
	public title: string = "";

}



// WEBPACK FOOTER //
// ./src/panels/organizations/admin/Config.ts